// Reports Page

import React from "react";

// Custom
import Layout from "../../layout";

const Reports: React.FC = () => {
  return (
    <Layout>
      <div>index</div>
    </Layout>
  );
};

export default Reports;
